import React, { PropsWithChildren } from 'react';

import HeaderDesktop from 'layouts/header/header.desktop';
import Layout from './layout';
import FooterDesktop from 'layouts/footer/footer.desktop';
import AdSlot from 'components/ads/ad-slot';
import { SLOT_CORNER, SLOT_SCROLLER, SLOT_SPONSORING_TOP } from 'components/ads/ad-slot/ad-defs';
import AdSlotCorner from 'components/ads/ad-slot-corner';

import './layout.desktop.scss';

interface LayoutDesktopProps {
    isHomepage?: boolean;
}

const LayoutDesktop: React.FC<PropsWithChildren<LayoutDesktopProps>> = ({ isHomepage, children }) => (
    <div className="root">
        <AdSlot name={SLOT_SPONSORING_TOP} className="onet-ad__sponsoring" />
        <HeaderDesktop isHomepage={isHomepage} />
        <Layout>
            {children}
        </Layout>
        <FooterDesktop />
        <AdSlot name={SLOT_SCROLLER} className="onet-ad__scroller" />
        <AdSlotCorner name={SLOT_CORNER} />
    </div>
);

export default LayoutDesktop;
